module.exports = __webpack_public_path__ + "img/590924television-canaria.5ae4dc2d.jpg";